import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M6 9H4.5C3.673 9 3 9.673 3 10.5V12c0 .827.673 1.5 1.5 1.5H6c.827 0 1.5-.673 1.5-1.5v-1.5C7.5 9.673 6.827 9 6 9m-1.5 3v-1.5H6V12zm9.75-10.5h-.75V.75a.75.75 0 1 0-1.5 0v.75H6V.75a.75.75 0 1 0-1.5 0v.75h-.75A3.754 3.754 0 0 0 0 5.25v9A3.754 3.754 0 0 0 3.75 18h10.5A3.754 3.754 0 0 0 18 14.25v-9a3.754 3.754 0 0 0-3.75-3.75M3.75 3h10.5c1.24 0 2.25 1.01 2.25 2.25V6h-15v-.75C1.5 4.01 2.51 3 3.75 3m10.5 13.5H3.75c-1.24 0-2.25-1.01-2.25-2.25V7.5h15v6.75c0 1.24-1.01 2.25-2.25 2.25"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }